/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Even_Quick_Grebe_GraspInputs */

const fr_even_quick_grebe_grasp = /** @type {(inputs: Even_Quick_Grebe_GraspInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjà acheté`)
};

/**

* @param {Even_Quick_Grebe_GraspInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const even_quick_grebe_grasp = /** @type {((inputs?: Even_Quick_Grebe_GraspInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Even_Quick_Grebe_GraspInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_even_quick_grebe_grasp(inputs)
});